import { gettext } from '@eventbrite/i18n';
import React from 'react';
import './ActionsPanel.scss';

type ActionsPanelProps = {
    isShareable: boolean;
    isEnded: boolean;
};

export const ActionsPanel = ({ isShareable, isEnded }: ActionsPanelProps) => {
    const canBeShared = isShareable && !isEnded;

    return (
        <div className="actions-panel">
            <h2 className="eds-is-hidden-accessible">
                {gettext('Actions Panel')}
            </h2>
            <ul className="actions-panel__list">
                <li className="actions-panel__item eds-fx--fade-in-down eds-fx--duration-2 fx--delay-14 z-1">
                    <span id="listings-root__bookmark-desktop"></span>
                </li>
                {canBeShared && (
                    <li className="actions-panel__item actions-panel__item--share eds-fx--fade-in-down eds-fx--duration-1 fx--delay-12">
                        <span id="listings-root__share-event-modal"></span>
                    </li>
                )}
            </ul>
        </div>
    );
};
